import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import {
  Form,
  Button,  
  Radio,
  Label
} from 'semantic-ui-react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import { ldapActions } from '../../actions/ldap.actions';
import { userConstants } from '../../constants/user.constants';

class LdapFormScreen extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ldapServer: {    
        host: '',
        port: 389,
        domain: "",
        filter: "",
        username: "",
        password: "",
        enabled: true
      },
      errors: {},
      submitted: false
    };    
  }

  componentDidMount() {
    const { match, dispatch } = this.props;    
    if (match.params.id) {
        dispatch(ldapActions.get(match.params.id))
            .then(() => {                
                const ldapServer = _.mapKeys(this.props.ldapServer, function (v, k) { return k.toLowerCase(); });                
                this.setState({ ldapServer })
            });
    }    
  }

  static get propTypes() { 
    return {       
        me: PropTypes.any,        
        ldapServer: PropTypes.any,
        loading: PropTypes.bool,
        match: PropTypes.any,
    }; 
  }

  handleChange(field, data) {            
    const { ldapServer } = this.state;    
    ldapServer[field] = data;    
    this.setState({ ldapServer });    
  }

  validate() {
    const { ldapServer } = this.state;
    
    let errors = {};
    let valid = true;

    if (!ldapServer.host || ldapServer.host.length == 0) {
      errors.host = "Preencha o host";
      valid = false;
    }

    if (!ldapServer.port || ldapServer.port <= 0) {
      errors.port = "Preencha a porta";
      valid = false;
    }

    if (!ldapServer.filter) {
      errors.filter = "Preencha o filtro";
      valid = false;
    }

    this.setState({ errors });
    return valid;
  }

  handleSubmit() {
    if (!this.validate()) {
      return;
    }

    const { dispatch } = this.props;
    const { ldapServer } = this.state;    

    if (ldapServer.id) {
        dispatch(ldapActions.update(ldapServer.id, ldapServer));
    } else {
        dispatch(ldapActions.create(ldapServer));
    }
  }

  render() {    
    const { ldapServer, errors } = this.state;        
    const { me } = this.props;

    // Check Permission    
    if (me && me.Role != userConstants.ROLE_ADMIN) {
      window.location.href = "/";
      return;
    }
    
    const typeOptions = [
      { value: 2, key: 2, text: 'Active Directory' },
      { value: 1, key: 1, text: 'LDAP' },
    ]    
    return (  
      <Fragment>
      <h1>Servidor de Autenticação</h1>
      <Form loading={this.props.loading} onSubmit={() => this.handleSubmit()}>
        <Form.Select required error={errors.type} label='Tipo' value={ldapServer.type} name='type' onChange={(e, data) => this.handleChange("type", data.value)} options={typeOptions} />
        <Form.Input required error={errors.host} label='Host' value={ldapServer.host} name='host' type='text' onChange={(e, data) => this.handleChange("host", data.value)} placeholder='Hostname ou IP' />
        { errors.host && <Label color='red'>{errors.host}</Label>}

        <Form.Input required error={errors.port} label='Porta' value={ldapServer.port} name='port' type='number' onChange={(e, data) => this.handleChange("port", data.value)} placeholder='389' />
        { errors.port && <Label color='red'>{errors.port}</Label>}

        <Form.Input error={errors.domain} label='Base DN' value={ldapServer.domain} name='domain' type='text' onChange={(e, data) => this.handleChange("domain", data.value)} placeholder='Ex: DC=local,DC=empresa' />
        { errors.domain && <Label color='red'>{errors.domain}</Label>}

        <Form.Input required error={errors.filter} label='Filtro Usuários' value={ldapServer.filter} name='filter' type='text' onChange={(e, data) => this.handleChange("filter", data.value)} placeholder='Query LDAP' />
        { errors.filter && <Label color='red'>{errors.filter}</Label>}

        <Form.Input error={errors.username} label='Usuário' value={ldapServer.username} name='username' type='nutextmber' onChange={(e, data) => this.handleChange("username", data.value)} />
        { errors.username && <Label color='red'>{errors.username}</Label>}

        <Form.Input error={errors.password} label='Senha' value={ldapServer.password} name='password' type='password' onChange={(e, data) => this.handleChange("password", data.value)} placeholder='Deixe em branco para manter' />
        { errors.password && <Label color='red'>{errors.password}</Label>}

        <Form.Input>
            <Radio toggle checked={ldapServer.enabled} label='Habilitado' onChange={(e, data) => this.handleChange("enabled", data.checked)} />
        </Form.Input>
                
        <Button primary type='submit'>{ldapServer.id ? 'Alterar' : 'Criar'} Servidor</Button>
      </Form>
    </Fragment>
    );
  }
}

function mapStateToProps(state) {
  const { users, ldapServers } = state;  
  let props = {
    me: users.me || null,    
    loading: ldapServers.loading,    
  };

  if (ldapServers && ldapServers.item) {
      props.ldapServer = ldapServers.item;      
  }
  
  return props;
}

const connectedLdapFormScreen = connect(mapStateToProps)(LdapFormScreen);
export { connectedLdapFormScreen as LdapFormScreen };
